import api from "./axios";

export const createOrganizer = async (payload) => {
  const response = await api.post("/companies", payload);
  return response.data;
};

export const getOrganizers = async (payload) => {
  const response = await api.get("/companies", payload);
  return response.data;
};

export const getOrganizerById = (id) => {
  return api.get(`/companies/${id}`);
};

export const updateOrganizer = async (id, payload) => {
  const response = await api.put(`/companies/${id}`, payload);
  return response.data;
};

export const deleteOrganizer = (id) => {
  return api.put(`/companies/delete/${id}`);
};

